import React from "react";
import { Link, withRouter } from "react-router-dom";
import { getPolicyUser } from "../../helpers/api_helper";

const Columns = (addUpd, destroy) => {
  const policy = getPolicyUser();
  let columns = [
    {
      id: "id",
      name: "Folio",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
      compact: true
    },
    {
      id: "fecha",
      name: "Fecha",
      selector: (row) => row.fecha,
      sortable: true,
      width: "150px",
      compact: true
    },
    {
      id: "technicals_names",
      name: "Técnicos",
      selector: (row) => row.technicals_names,
      sortable: false,
      compact: true
    },
    {
      id: "no_ruta",
      name: "Ruta",
      selector: (row) => row.no_ruta,
      sortable: true,
      compact: true
    },
    {
      id: "unidad",
      name: "Unidad",
      selector: (row) => row.unidad,
      sortable: true,
      width: "100px",
      compact: true
    },

    {
      id: "actions",
      name: "Acciones",
      width: "20%",
      button: true,
      compact: true,
      cell: (row) => (
        <>
          <div className="p-1">
            <Link
              to={`/instalacion/mostrar/${row.id}`}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-eye" />
            </Link>
          </div>

          <div className="p-1">
            <Link
              to={`/instalacion/${row.id}`}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-edit"></i>
            </Link>
          </div>

          <div className="p-1">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar instalación"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </>
      ),
    },
  ];
  return columns;
};

export default Columns;
